export default __webpack_public_path__ + "static/media/twitter.da0017b6.svg";